import "reflect-metadata";
import {inject, injectable} from "inversify";
import {UserRepository} from "@dropDesk/domain/repositories/user/user.repository";

@injectable()
export class ChangeEmailUserUseCase {
  private _repository: UserRepository;

  constructor(@inject(UserRepository) repository: UserRepository) {
    this._repository = repository;
  }

  public call(oldEmail: string, newEmail: string, isCurrentUserChanged: boolean): Promise<void> {
    return this._repository.changeEmail(oldEmail, newEmail, isCurrentUserChanged);
  }
}

